import { render, staticRenderFns } from "./NewsRead.vue?vue&type=template&id=4554d626&scoped=true&"
import script from "./NewsRead.vue?vue&type=script&lang=js&"
export * from "./NewsRead.vue?vue&type=script&lang=js&"
import style0 from "./NewsRead.vue?vue&type=style&index=0&id=4554d626&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4554d626",
  null
  
)

export default component.exports